var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StateDropdownSelectClassification',{staticClass:"w-full",attrs:{"outline":"","value":_vm.state,"menu":_vm.items,"placeholder":'全部',"all-select-text":'全部'}})
}
var staticRenderFns = []

export { render, staticRenderFns }